"use client";

import { useSyncExternalStore } from "react";
import { isWebglMapSupported } from "@/lib/maps/webgl-support";

const subscribe = () => () => {};
const getServerSnapshot = () => true;

export function useWebglMapSupported(): boolean {
  return useSyncExternalStore(subscribe, isWebglMapSupported, getServerSnapshot);
}
